import { userService } from '../services/userService';
import { API_ENDPOINT } from '../app/config';

function getHeaders(isAuthorizedRequest) {
  return {
    'Content-Type': 'application/json',
    ...(isAuthorizedRequest ? { token: `${userService.getToken()}` } : {})
  };
}

let lastReCallPath;
let isReCall = false;

function logout() {
  userService.logout();
  window.location.reload(true);
}

function rejectLogout(data) {
  logout();
  return Promise.reject(data);
}

export function call(
  path,
  method = 'GET',
  body = null,
  isAuthorizedRequest = true,
  apiEndpoint = null
) {
  const requestOptions = {
    method: method,
    headers: getHeaders(isAuthorizedRequest),
    ...(body ? { body: JSON.stringify(body) } : {})
  };
  const args = arguments;
  apiEndpoint = apiEndpoint || API_ENDPOINT;
  return fetch(encodeURI(`${apiEndpoint}/${path}`), requestOptions).then(
    response => {
      return response
        .text()
        .then(text => {
          const data = text && JSON.parse(text);
          if (!response.ok) {
            if (response.status === 406 && isAuthorizedRequest) {
              // auto re-login or logout if 406 response returned from api
              const creds = userService.getUserCreds();
              if (creds) {
                return userService.login(creds).then(() => {
                  if (isReCall) {
                    return rejectLogout();
                  }

                  lastReCallPath = path;
                  isReCall = true;
                  return call.apply(null, args);
                });
              }
              logout();
            }
            return Promise.reject(data);
          }
          if (lastReCallPath === path) {
            isReCall = false;
            lastReCallPath = null;
          }
          return data;
        })
        .catch(e => {
          return Promise.reject(e);
        });
    }
  );
}



// WEBPACK FOOTER //
// ./src/utils/api.js